<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.posScreen')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="card mar-to-15">
      <div class="card-content">
        <div class="text-right">
          <p class="">
            <button class="btn add"  @click.prevent="goToAdd" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
              <img src="/static/img/icons/add.png">
              {{$t('general.add')}}
            </button>
          </p>
        </div>
        <data-tables
              v-loading="loading"
              :data="modelData"
              :search-def="{}"
              :pagination-def="{}"
              :table-props="{'border': false}"
              style="width: 100%">
          <el-table-column
              min-width="50"
              prop="name"
              :label="$t('customers.name')">
          </el-table-column>
          <el-table-column
                min-width="50"
                prop="location_name"
                :label="$t('customers.location')">
            <template slot-scope="props">
              <span v-if="props.row.location && props.row.location.name">{{ props.row.location.name }}</span>
              <span v-else>{{$t('general.all')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :width="200"
            :label="$t('general.actions')">
            <template slot-scope="props">
              <a
                class="btn delete mar-rt-10"
                :title="$t('general.delete')"
                @click="deleteOrderScreen(props.row.id)">
                <img src="/static/img/icons/icon-close.png">
                {{$t('general.delete')}}
              </a>
            </template>
          </el-table-column>
          <!-- <el-table-column
            :width="120"
            :label="$t('general.copyUrlToClipboard')">
            <template slot-scope="props">
              <button class="btn btn-icon btn-info duplicate mar-rt-10"
                      @click="copyToClipboard(props.row.url)"
                      :title="$t('general.copyUrlToClipboard')">
                <img src="/static/img/icons/duplicate.png">
              </button>
            </template>
          </el-table-column> -->
          <el-table-column
            :width="150"
            :label="$t('general.edit')">
            <template slot-scope="props">
              <div class="edit" @click="goToRecord(props.row, $event, props.row)">
                <i class="fa fa-pencil"></i>{{$t('general.edit')}}
              </div>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      // GeneralTopBar,
      [Input.name]: Input
    },
    props: {
      // callback: {
      //   required: false
      // },
      // callbackAdd: {
      //   required: false
      // },
      // isTable: {
      //   type: Boolean,
      //   default: false
      // }
    },
    created () {
      this.getData()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    data () {
      return {
        loading: true,
        tableColumns: [
          {
            prop: 'type',
            label: this.$t('settingTable.type'),
            minWidth: 50
          },
          {
            prop: 'location_name',
            label: this.$t('settingTable.location'),
            minWidth: 50
          },
          {
            prop: 'section.name',
            label: this.$t('kds.name'),
            minWidth: 50
          }
        ],
        modelData: []
      }
    },
    methods: {
      handleRefresh () {
        this.getData()
      },
      goToRecord (row, event, column) {
        if (typeof this.callback === 'function') {
          this.callback(row.id)
        } else {
          this.globalGoToRecord(row, event, column, '/pos/screen/edit/')
        }
      },
      getData () {
        var data = {
          token: this.$session.get('token'),
          type: 2,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/pos/all/screens', 'GET', data, (response) => {
          if (response.status === true) {
            this.modelData = response.data.screens
            this.$nextTick(function () {
              this.loading = false
            })
          }
        })
      },
      goToAdd () {
        this.$router.push('/pos/screen/add')
      },
      copyToClipboard (url) {
        url = url.replace(/\s/g, '')
        this.$copyText(url)
      },
      deleteOrderScreen (id) {
        this.$nextTick(() => { this.loadingReset = true })
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/pos/screens/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          } else {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
          this.getData()
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/OrderScreen/PosScreen.vue